import { Box, PageLayout } from "@primer/react";
import React, { createContext, useState } from "react";
import Header from "./header";
import Menu from "./menu";

export interface ILayoutContext {
    setHideSubNav?: (hide: boolean) => void;
}

export const LayoutContext = createContext<ILayoutContext>({});

interface ILayoutProps {
  children?: React.ReactNode;
}
const Layout = (props: ILayoutProps) => {
  const [hideSubNav, setHideSubNav] = useState(false);
  return (
    <LayoutContext.Provider value={{ setHideSubNav }}>
    <PageLayout
      containerWidth="full"
      sx={{
        padding: 0,
      }}
    >
      <>
        <PageLayout.Header
          sx={{
            marginBottom: 0,
            borderBottom: 0,
          }}
        >
          <Header />
        </PageLayout.Header>

        {!hideSubNav && (
          <PageLayout.Pane
            sx={{
              maxWidth: "200px",
              width: "200px",
              marginRight: "0px!important",
              backgroundColor: "rgba(255,255,255,0.6)",
              backdropFilter: "blur(16px)",
            }}
            position={"start"}
          >
            <Box
              height={window.innerHeight - 90}
              overflow={"auto"}
              sx={{
                borderRightWidth: "1px",
                borderRightStyle: "solid",
                borderRightColor: "border.default",
                m: 0,
              }}
            >
              <Menu />
            </Box>
          </PageLayout.Pane>
        )}
        <PageLayout.Content
          sx={{
            p: 0,
            backgroundColor: "rgba(255,255,255,0.6)",
            backdropFilter: "blur(16px)",
          }}
        >
          <Box
            height={window.innerHeight - 90}
            overflow={"auto"}
            sx={{
              borderRadius: "10px",
              backgroundColor: "#fff",
              mr: 1,
              mb: 1,
            }}
          >
            {props.children && <>{props.children}</>}
          </Box>
        </PageLayout.Content>
      </>
    </PageLayout>
    </LayoutContext.Provider>
  );
};

export default Layout;
